import { render } from "./ConfirmationBanner.vue?vue&type=template&id=53ca3ed2&scoped=true"
import script from "./ConfirmationBanner.vue?vue&type=script&lang=js"
export * from "./ConfirmationBanner.vue?vue&type=script&lang=js"

import "./ConfirmationBanner.vue?vue&type=style&index=0&id=53ca3ed2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-53ca3ed2"

export default script